import { breakingFeed } from '@/mocks/home';

export default function BreakingFeed() {
  return (
    <section id="feed" className="w-full border-t border-background-200 bg-background-100 px-4 md:px-8 py-12 md:py-20">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12">
        <div className="lg:col-span-4 lg:sticky lg:top-32 self-start">
          <span className="text-xs font-label tracking-[0.3em] text-primary-600">01 / 快讯流</span>
          <h3 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">今日快讯</h3>
          <p className="mt-4 text-sm leading-7 text-foreground-600">
            当天整理动态按时间刷新，先看快的，再进合集慢慢翻。每条都标注了它归属的合集位置。
          </p>
          <a
            href="#archive"
            className="mt-6 inline-flex items-center gap-2 text-sm font-label text-primary-600 transition-colors hover:text-primary-700 whitespace-nowrap cursor-pointer"
          >
            查看全部归档
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line" />
            </span>
          </a>
        </div>

        <ol className="lg:col-span-8 relative border-l border-background-300 pl-6 md:pl-10 space-y-8 md:space-y-10">
          {breakingFeed.map((item) => (
            <li key={`${item.time}-${item.title}`} className="relative">
              <span className="absolute -left-[30px] md:-left-[46px] top-2 w-3 h-3 rounded-full bg-accent-500 ring-4 ring-background-100" />
              <div className="flex flex-wrap items-center gap-3">
                <time className="font-heading text-lg md:text-xl font-bold text-foreground-950">{item.time}</time>
                <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] font-label text-secondary-900">
                  {item.tag}
                </span>
              </div>
              <h4 className="mt-2 text-base md:text-lg font-medium text-foreground-900">
                <a href="#archive" className="transition-colors hover:text-primary-600 cursor-pointer">
                  {item.title}
                </a>
              </h4>
              <p className="mt-1 text-sm text-foreground-600">{item.detail}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}